var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJustVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2669_2573)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45899 -0.0214844C7.48374 -0.0214844 11.5085 -0.0214844 15.5332 -0.0214844C17.1478 1.49987 18.7448 3.04674 20.3242 4.61914C20.3994 4.73713 20.4424 4.86604 20.4531 5.00586C20.4952 10.0197 20.4809 15.0327 20.4102 20.0449C20.1661 21.0839 19.5287 21.7284 18.498 21.9785C13.485 21.9785 8.47202 21.9785 3.45899 21.9785C2.4272 21.7273 1.78983 21.0828 1.54688 20.0449C1.51823 14.0006 1.51823 7.95639 1.54688 1.91211C1.79098 0.873103 2.42835 0.228573 3.45899 -0.0214844ZM3.93164 1.26758C7.49805 1.26758 11.0645 1.26758 14.6309 1.26758C14.6237 2.32757 14.6309 3.38747 14.6523 4.44727C14.7978 5.09403 15.1916 5.50223 15.834 5.67188C16.9368 5.69336 18.0396 5.70054 19.1426 5.69336C19.1498 10.3197 19.1426 14.946 19.1211 19.5723C19.0423 20.224 18.6771 20.5892 18.0254 20.668C13.2261 20.7103 8.42793 20.696 3.63086 20.625C3.13697 20.4463 2.872 20.0954 2.83594 19.5723C2.80729 13.8431 2.80729 8.11392 2.83594 2.38477C2.92238 1.73261 3.28761 1.36021 3.93164 1.26758ZM15.9629 2.25586C16.6977 2.92619 17.4139 3.62085 18.1113 4.33984C17.4238 4.3685 16.7363 4.3685 16.0488 4.33984C16.0273 4.31836 16.0059 4.29688 15.9844 4.27539C15.9629 3.60237 15.9557 2.92919 15.9629 2.25586Z",
    fill: "#53545C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12304 10.2058C9.31708 10.1986 12.5111 10.2058 15.7051 10.2273C16.1299 10.4868 16.2229 10.8377 15.9844 11.28C15.895 11.3498 15.8019 11.4142 15.7051 11.4734C12.5111 11.5021 9.31704 11.5021 6.12304 11.4734C5.6888 11.2159 5.59573 10.865 5.84375 10.4207C5.92818 10.3326 6.02129 10.2609 6.12304 10.2058Z",
    fill: "#53545C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12304 12.7839C8.75849 12.7768 11.3939 12.7839 14.0293 12.8054C14.4779 13.0889 14.5567 13.4542 14.2656 13.9011C14.1869 13.9513 14.1081 14.0014 14.0293 14.0515C11.3939 14.0802 8.75845 14.0802 6.12304 14.0515C5.6888 13.7941 5.59573 13.4431 5.84375 12.9988C5.92818 12.9107 6.02129 12.8391 6.12304 12.7839Z",
    fill: "#53545C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12304 15.3621C9.05927 15.3549 11.9955 15.3621 14.9316 15.3836C15.3124 15.6098 15.4198 15.9321 15.2539 16.3503C15.1592 16.4595 15.0517 16.5526 14.9316 16.6296C11.9955 16.6583 9.05923 16.6583 6.12304 16.6296C5.6888 16.3722 5.59573 16.0213 5.84375 15.5769C5.92818 15.4888 6.02129 15.4172 6.12304 15.3621Z",
    fill: "#53545C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2669_2573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustVisit);
export default __webpack_public_path__ + "static/media/justVisit.71b3396d2d14518132895806d3ba96fd.svg";
export { ForwardRef as ReactComponent };